import { render, staticRenderFns } from "./additional-rewards.vue?vue&type=template&id=c649f398&scoped=true"
import script from "./additional-rewards.vue?vue&type=script&lang=js"
export * from "./additional-rewards.vue?vue&type=script&lang=js"
import style0 from "./additional-rewards.vue?vue&type=style&index=0&id=c649f398&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c649f398",
  null
  
)

export default component.exports